import React from "react";
import { styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { Add as AddIcon } from "@mui/icons-material";
import formStyles from "../utils/formStyles";

const btnStyle = {
  margin: "0 8px 0 2px",
  padding: 0,
};

const PREFIX = "Autocomplete2";
const classes = formStyles;

const Root = styled("div")(({ theme }) => ({
  [`& .${PREFIX}-option`]: {
    ...classes.option,
  },
  [`& .${PREFIX}-autocomplete`]: {
    ...classes.autocomplete,
  },
  [`& .${PREFIX}-autocomplete .MuiOutlinedInput-notchedOutline legend`]: {
    display: "none",
  },
}));

function Autocomplete2(props) {
  const {
    disabled,
    error,
    value,
    options,
    className,
    label,
    size,
    onChange,
    onAdd,
    compact,
    getOptionSelected = (option, value) => option.Code === value.Code, // deprecated in MUI v5
    getOptionLabel = (option) => (option.Code ? option.Code : ""),
    renderOption = (props, option) => (
      <li {...props}>
        <span>
          <strong>{option.Code}</strong>
          {!!option.Description && <> - {option.Description}</>}
        </span>
      </li>
    ),
  } = props;

  const helperText =
    compact && compact !== false
      ? undefined
      : typeof error === "string"
      ? error
      : " ";

  return (
    <Root className={className}>
      <Autocomplete
        options={options || []}
        classes={{
          option: `${PREFIX}-option`,
          root: `${PREFIX}-autocomplete`,
        }}
        disabled={disabled}
        autoHighlight
        isOptionEqualToValue={(option, value) => option.Code === value.Code} // replaces getOptionSelected
        getOptionLabel={getOptionLabel}
        renderOption={renderOption}
        onChange={onChange}
        value={value}
        renderInput={(params) => (
          <TextField
            {...params}
            error={!!error}
            helperText={helperText}
            label={label}
            variant="outlined"
            size={size || "small"}
            InputProps={{
              ...params.InputProps,
              autoComplete: "new-password",
              startAdornment: Boolean(onAdd) ? (
                <IconButton style={btnStyle} onClick={onAdd}>
                  <AddIcon fontSize="small" />
                </IconButton>
              ) : null,
            }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
            }}
          />
        )}
      />
    </Root>
  );
}

export default Autocomplete2;
